module.exports = __webpack_public_path__ + "img/WeChat.ee4787aa.png";